module.exports = __webpack_public_path__ + "static/media/error-404.7b4aa2eb.svg";